import { useTranslation } from "react-i18next";

/**
 * Requirements §6.4: horizon controls are forward-looking or age-based and
 * belong to their card, never to the page — a global-looking period
 * control on a snapshot-only tab is exactly the "present-but-inert"
 * problem §5.1 rules out.
 *
 * Options are capped at the server's fetch ceiling and the ceiling is
 * stated, so a 60-day question never silently gets a 30-day answer.
 */
const HORIZON_OPTIONS = [7, 14, 30];

const HorizonControl = ({ value, onChange, ceilingDays = 30 }) => {
  const { t } = useTranslation("coaching-portal");
  const options = HORIZON_OPTIONS.filter((days) => days <= ceilingDays);

  return (
    <div className="horizon-control">
      <label>
        <p className="s1">{t("income.attention.horizonLabel")}</p>
        <select
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
        >
          {options.map((days) => (
            <option key={days} value={days}>
              {t("income.attention.horizonOption", { count: days })}
            </option>
          ))}
        </select>
      </label>
      <p className="p2 text-xs">
        {t("income.attention.horizonCeiling", { count: ceilingDays })}
      </p>
    </div>
  );
};

export default HorizonControl;
